import type React from "react";
import {useAuthState} from "react-firebase-hooks/auth";

import {usePersonalBestV2} from "~/api/hooks/usePersonalBestV2";
import TimeSince from "~/component/common/TimeSince";
import {auth} from "~/firebase/firebase";
import {formatCompletionSteps} from "~/util/timeUtils";

const PerformanceInformation: React.FC<{levelId?: string}> = ({levelId}) => {
  const [myUser] = useAuthState(auth);

  // Get personal best data
  const {data: personalBestV2} = usePersonalBestV2({
    levelId,
    id: myUser?.uid,
  });

  // Use the personal best data
  const personalBest = personalBestV2?.replay;
  const personalBestSteps = personalBest?.totalSteps;
  const personalBestTimestamp = new Date(); //TODO: FIx

  return (
    <div className="my-2 text-center">
      <p className="text-xl">
        Personal Best:
        <span className="text-green-300 ml-2">
          {personalBestSteps ? formatCompletionSteps(personalBestSteps) : "N/A"}
        </span>
      </p>
      {personalBestTimestamp && (
        <p className="text-sm">
          Completed
          <span className="ml-1 text-gray-500">
            <TimeSince date={personalBestTimestamp} />
          </span>
        </p>
      )}
    </div>
  );
};

export default PerformanceInformation;
